import Layout from '@layout/Index'

export const userWorkInfo = [
  {
    path: '/user-workinfo',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "user-work-info-table" */ './pages/UserWorkInfoTable.vue'),
        meta: {
          title: '职业信息审核列表',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "user-work-info-form" */ './pages/UserWorkInfoDetail.vue'),
        meta: {
          title: '职业信息提交详情',
          type: 'detail'
        },
      },
      {
        path: 'audit/:id',
        component: () => import(/* webpackChunkName: "user-work-info-detail" */ './pages/UserWorkInfoDetail.vue'),
        meta: {
          title: '职业信息审核',
          type: 'audit'
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/user-workinfo/user-workinfo.route.js